export const hasType =
  <BASE, INTERFACE extends BASE, TYPE>(object: any, name: TYPE, fieldName: string = 'type'): object is INTERFACE => {
    return object[fieldName] === name;
  }